import React from 'react'
import {Testimonials} from "../Testimonials/Testimonial"

export const Testimonial = () => {
  return (
    <>
    <h2 style={{textAlign:'center',color:'#dc3545', margin:"60px 0px"}}>Testimonial</h2>
          <div>
            <Testimonials />
          </div>
    </>
    
  )
}
